module.exports = __webpack_public_path__ + "img/network.805c3184.png";